import React from "react";
import "./AffirmCancellation.scss"
import { CardLayout } from "components/cardLayout";
import { amslogo, logo } from 'assets/images';
import { Button } from "components/button";
import { navigate } from "@reach/router";

export interface AffirmCancellationProps {

}

export interface AffirmCancellationState {

}

class AffirmCancellation extends React.Component<AffirmCancellationProps, AffirmCancellationState> {
    constructor(props: AffirmCancellationProps) {
        super(props);
        this.state = {};
    }
    continue(){
        //  alert("inn")
          navigate("/affirm");
      }
    gotoPayment(){
        
        navigate("/move?question=deposit");
    }
    render() {
        return (
            <div className="cancellation-container">
                <CardLayout>
                    <div className="affirm-logo">
                        <div className="logo-img">
                            <img src={logo} alt="logo" />
                        </div>
                        <div>
                            <p>+</p>
                        </div>
                        <div className="logo-img">
                            <img src={amslogo} />
                        </div>
                    </div>
                    <div className="cancellation-info">
                        <p>Would you like to continue to Affirm?</p>
                    </div>
                    <div className="cancel-btn">
                        <Button text="Continue"
                            backgroundColor={"#4E9CE6"}
                            onClick={() => this.continue()}
                        />
                        <Button text="Skip Now"
                            backgroundColor={"#ffffff"}
                            marginTop={"0em"}
                            border={"3px solid #4E9CE6"}
                            color={"#4E9CE6"}
                            style={{}}
                            onClick={() => this.gotoPayment()}
                        />
                    </div>
                </CardLayout>
            </div>
        );
    }
}

export default AffirmCancellation;